const setNumberOfPresentationPages = (state, payload) => {
  state.numbers.numberOfPresentationPages = payload
}

const setNumberOfLoadedPresentationPages = (state, payload) => {
  state.numbers.numberOfLoadedPresentationPages = payload
}

export default {
  setNumberOfPresentationPages,
  setNumberOfLoadedPresentationPages,
}
